// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RMDfFYrQYB_pHWpmxJ6vO","groupsList":"_3t9Pu-xaLXLoIMPGjDlxkT"};